// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"rp-z","slideIn":"sp-z"};